import styled from 'styled-components'

const RelatedBlogPostsStyle = styled.div`
	--rbpTitleMarginBottom: var(--sp8x);
	--rbpButtonMarginTop: var(--sp8x);

	.rpb-container {
		overflow: hidden;

		.rpb-container-title {
			margin-bottom: var(--rbpTitleMarginBottom);
		}

		.rpb-items-container > .row {
			margin-bottom: calc(-2 * var(--colPadding));
		}

		.rpb-load-more-button {
			display: flex;
			justify-content: center;
			margin-top: var(--rbpButtonMarginTop);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--rbpTitleMarginBottom: var(--sp7x);
		--rbpButtonMarginTop: var(--sp7x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--rbpTitleMarginBottom: var(--sp6x);
		--rbpButtonMarginTop: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--rbpTitleMarginBottom: var(--sp6x);
		--rbpButtonMarginTop: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--rbpTitleMarginBottom: var(--sp5x);
		--rbpButtonMarginTop: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--rbpTitleMarginBottom: var(--sp4x);
		--rbpButtonMarginTop: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--rbpTitleMarginBottom: var(--sp4x);
		--rbpButtonMarginTop: var(--sp5x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--rbpTitleMarginBottom: var(--sp4x);
		--rbpButtonMarginTop: var(--sp5x);
	}
`

export default RelatedBlogPostsStyle
